

<template>
  <div class="second-card" :style="{ position: isTip ? 'relative' : 'unset' }">
    <!-- 背景图片 -->
    <img 
      v-if="!isTip" 
      class="bg-img static" 
      src="../../../assets/icon_dean_home_bg_card_6.png" 
      alt="" 
    />
    <img 
      v-if="isTip" 
      class="bg-img absolute" 
      src="../../../assets/icon_dean_home_bg_card_1_1.png" 
      alt="" 
    />
    
    <!-- 主内容容器 -->
    <div class="main-container">
      <div class="content-wrapper" :style="{ pointerEvents: isTip ? 'none' : 'unset' }">
        <!-- 标题栏 -->
        <div class="header">
          <div class="title-group">
            <div class="title-tag"></div>
            <div class="title-text">需要长期观察的长者</div>
            <div class="count-badge" :style="{ opacity: data ? 1 : 0 }" v-if="data">
              <img src="../../../assets/icon_common_special_arrow_2.png" alt="" />
              <div class="count-text">{{ dataLength + '位' }}</div>
            </div>
          </div>
          
          <div class="header-actions" v-if="data && dataLength > 0">
            <img src="../../../assets/icon_dean_home_bg_card_icon_1.png" alt="" />
            <div class="see-all" @click="seeAll">
              <span>查看全部</span>
              <img src="../../../assets/icon_dean_home_bg_card_icon_8.png" alt="" />
            </div>
          </div>
        </div>
        
        <!-- 空状态 -->
        <div class="empty-state" v-if="!data && emptyString !== '院长端未关联任何设备'">
          <img 
            :src="getEmptyImage()" 
            alt="" 
          />
          <div class="empty-text">{{ emptyString || ' ' }}</div>
        </div>
        
        <!-- 数据内容区 -->
        <div class="data-content" v-if="data">
          <!-- 轮播容器 -->
          <div class="carousel-container">
            <el-carousel 
              :interval="5000000" 
              arrow="never" 
              height="234px" 
              :loop="false" 
              indicator-position="none" 
              ref="homeDeanSecondCardRef" 
              @change="carouselChange"
            >
              <el-carousel-item v-for="(item, index) in data" :key="index">
                <div class="carousel-items">
                  <div 
                    class="mini-card" 
                    @click="itemClick(subItem)" 
                    v-for="(subItem, subIndex) in item" 
                    :key="subIndex"
                    :class="{ 'last-item': subIndex === 4 }"
                  >
                    <div class="mini-card-content">
                      <div class="mini-card-inner">
                        <!-- 描述列表 -->
                        <div class="description-list">
                          <div 
                            class="description-item"
                            v-for="(miniItem, miniIndex) in subItem.hasOccurPrfList || []" 
                            :key="miniIndex"
                          >
                            <div class="description-text">{{ miniItem }}</div>
                          </div>
                        </div>
                        
                        <!-- 操作区 -->
                        <div class="mini-card-actions">
                          <div class="more-indicator" v-if="subItem && subItem.hasOccurPrfList && subItem.hasOccurPrfList.length > 3">…</div>
                          <div class="view-btn">查看</div>
                        </div>
                      </div>
                      <img class="card-arrow" src="../../../assets/icon_common_special_arrow_4.png" alt="" />
                    </div>
                    
                    <!-- 床位信息 -->
                    <div class="bed-info">
                      <div class="bed-icon"></div>
                      <div class="bed-name">{{ subItem.bedName || '' }}</div>
                      <div class="bed-tooltip" :style="{ transform: subIndex != 0 ? 'translateX(-50%)' : 'translateX(50%)' }">
                        {{ subItem.bedName || '' }}
                      </div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            
            <!-- 轮播箭头 -->
            <img 
              class="carousel-arrow left"
              :src="require(`../../../assets/icon_dean_home_bg_card_icon_${leftBtnState === 1 ? 12 : 11}.png`)" 
              alt=""
              @click="clickArrow(1)"
              v-if="currentPage !== 1"
              @mouseover="leftBtnHover"
              @mouseout="leftBtnRemoveHover"
            />
            <img 
              class="carousel-arrow right"
              :src="require(`../../../assets/icon_dean_home_bg_card_icon_${rightBtnState === 1 ? 14 : 13}.png`)" 
              alt=""
              @click="clickArrow(2)"
              v-if="currentPage !== data.length"
              @mouseover="rightBtnHover"
              @mouseout="rightBtnRemoveHover"
            />
          </div>
          
          <!-- 服务标签 -->
					<div class="service-tags">
						<div class="tag-container">
							<img class="tag-corner" src="../../../assets/icon_dean_home_bg_card_icon_9.png" alt="" />
							<img class="tag-corner bottom-right" src="../../../assets/icon_dean_home_bg_card_icon_10.png" alt="" />
							
							<!-- 第一行标签：用 .tag-row 统一样式 -->
							<div class="tag-row">
							<div class="tag-item">
								<img src="../../../assets/icon_dean_home_bg_card_icon_2.png" alt="" />
								<span class="width-sm">慢病跟踪</span> <!-- 用类控制宽度，避免内联样式 -->
							</div>
							<div class="tag-divider"></div>
							<div class="tag-item">
								<img src="../../../assets/icon_dean_home_bg_card_icon_3.png" alt="" />
								<span class="width-lg">日常生活协助</span>
							</div>
							</div>
							
							<!-- 第二行标签：复用 .tag-row 样式 -->
							<div class="tag-row">
							<div class="tag-item">
								<img src="../../../assets/icon_dean_home_bg_card_icon_4.png" alt="" />
								<span class="width-sm">心理疏导</span>
							</div>
							<div class="tag-divider"></div>
							<div class="tag-item">
								<img src="../../../assets/icon_dean_home_bg_card_icon_5.png" alt="" />
								<span class="width-lg">康复&助眠等服务</span>
							</div>
							</div>
						</div>
					</div>
        </div>
      </div>
    </div>
    
    <!-- 提示弹窗 -->
    <div class="tip-popup" v-if="isTip">
      <div class="tip-content">
        <div class="tip-text-container">
          <div class="tip-text-mask"></div>
          <div class="tip-text">
            ·黄区老人可以看情况筛选关心：根据对老人实际健康状态的了解程度，周期性合理的进行慢病跟踪（例如：呼吸急促的老人、频繁起夜的老人等）
          </div>
        </div>
        <div class="tip-actions">
          <div class="tip-meta">
            <span>2/3</span>
            <span class="skip-tip" @click="skippingTutorial">跳过教程</span>
          </div>
          <div class="next-btn" @click="next">下一步</div>
        </div>
      </div>
      <img class="tip-arrow" src="../../../assets/icon_home_hei_san_jiao_2.png" alt="" />
    </div>
    
    <!-- 子组件 -->
    <SecondCardAllAlert ref="secondCardAllAlert" @itemClick="itemClick"></SecondCardAllAlert>
    <WorkProposalAlert ref="secondCardWorkProposalAlert" :type="1"></WorkProposalAlert>
  </div>
</template>

<script>
import SecondCardAllAlert from './secondCardAllAlert.vue'; 
import WorkProposalAlert from './workProposalAlert.vue';
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';

export default {
  components: {
    SecondCardAllAlert,
    WorkProposalAlert
  },
  filters: {
    reMate(val) {
      return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val));
    }
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    dataLength: {
      type: Number,
      default: 0
    },
    emptyString: {
      type: String,
      default: null
    },
    isTip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      leftBtnState: 0,
      rightBtnState: 0,
      currentPage: 1
    };
  },
  methods: {
    // 轮播页切换
    carouselChange() {
      this.currentPage = this.$refs.homeDeanSecondCardRef.activeIndex + 1;
    },
    
    // 轮播箭头点击
    clickArrow(type) {
      const carousel = this.$refs.homeDeanSecondCardRef;
      type === 1 ? carousel.prev() : carousel.next();
    },
    
    // 左侧箭头 hover 状态
    leftBtnHover() {
      this.leftBtnState = 1;
      this.rightBtnState = 0;
    },
    leftBtnRemoveHover() {
      this.leftBtnState = 0;
    },
    
    // 右侧箭头 hover 状态
    rightBtnHover() {
      this.rightBtnState = 1;
      this.leftBtnState = 0;
    },
    rightBtnRemoveHover() {
      this.rightBtnState = 0;
    },
    
    // 查看全部
    seeAll() {
      this.$refs.secondCardAllAlert.openAlert();
    },
    
    // 点击项
    itemClick(item) {
      this.$refs.secondCardWorkProposalAlert.openAlert(item);
    },
    
    // 跳过教程
    skippingTutorial() {
      this.$emit('skippingTutorial', 2);
    },
    
    // 下一步
    next() {
      this.$emit('next', 2);
    },
    
    // 获取空状态图片
    getEmptyImage() {
      const basePath = 'assets/icon_dean_home_card_empty_icon_';
      if (this.emptyString === '所有设备离线，请尽快检查设备情况，恢复守护状态') {
        return require(`@/${basePath}1.png`);
      } else if (this.emptyString === '睡眠设备赶紧用起来才能看到更多内容哦') {
        return require(`@/${basePath}2.png`);
      }
      return require(`@/${basePath}3.png`);
    }
  }
};
</script>

<style lang="scss" scoped>
// 先在 style 开头定义可复用变量（便于统一修改颜色、间距等）
$tag-container-bg: rgba(255, 255, 255, 0.8);
$tag-container-border: 1px solid #FFFFFF;
$tag-container-radius: 16px;
$tag-container-height: 100px;
$tag-container-width: 280px;
$tag-item-margin-x: 15px; // 标签左右间距
$tag-item-icon-size: 22px; // 标签图标尺寸
$tag-text-color: #5E6779;
$tag-text-size: 14px;
$divider-bg: #D5DADF;
$divider-height: 20px;
$divider-margin-x: 15px; // 分割线左右间距
.second-card {
  height: 393px;
  position: relative;
  display: flex;
  margin: 30px 0;
  margin-left: -50px;

  .bg-img {
    width: 575px;
    height: 473px;
    &.static {
      position: relative;
      left: -40px;
      top: -40px;
    }
    &.absolute {
      position: absolute;
      left: -40px;
      top: -40px;
    }
  }

  .main-container {
    position: absolute;
    width: 495px;
    height: 393px;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  // 标题栏样式
  .header {
    display: flex;
    height: 39px;
    justify-content: space-between;
    align-items: flex-end;

    .title-group {
      display: flex;
      align-items: center;

      .title-tag {
        width: 5px;
        height: 20px;
        background: #4A7CE8;
        border-radius: 0 3px 3px 0;
      }

      .title-text {
        font-size: 18px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #1F2635;
        line-height: 24px;
        margin-left: 15px;
      }

      .count-badge {
        display: flex;
        align-items: center;
        margin-left: 5px;

        img {
          width: 7px;
          height: 8px;
          z-index: 1;
        }

        .count-text {
          margin-left: -2px;
          background: #FBF6CB;
          border-radius: 4px;
          border: 1px solid #ECE271;
          padding: 2px 5px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #E6BA0A;
          line-height: 20px;
        }
      }
    }

    .header-actions {
      display: flex;
      align-items: center;
      margin-bottom: 7px;

      img:first-child {
        width: 73px;
        height: 14px;
        margin-right: 10px;
      }

      .see-all {
        display: flex;
        align-items: center;
        margin-right: 20px;
        cursor: pointer;

        span {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #4A7CE8;
          line-height: 22px;
          margin-right: 2px;
        }

        img:last-child {
          width: 16px;
          height: 16px;
        }
      }
    }
  }

  // 空状态样式
  .empty-state {
    width: 455px;
    height: 320px;
		margin-top: 20px;
		margin-left: 20px;
    background: #ECF0F3;
    box-shadow: inset 8px 8px 20px 0 #D1D9E6, inset -8px -8px 20px 0 #FFFFFF;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      width: 107px;
      height: 107px;
      z-index: 1;
    }

    .empty-text {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #A4ABB6;
      line-height: 20px;
      margin-top: 15px;
    }
  }

  // 数据内容区样式
  .data-content {
    height: 314px;
    display: flex;
    flex-direction: column;

    .carousel-container {
      height: 234px;
      position: relative;

      .carousel-items {
        width: 100%;
        height: 100%;
        display: flex;
        padding-left: 20px;
      }

      .mini-card {
        width: 220px;
        height: 199px;
        box-shadow: 5px 5px 8px 0 #D1D9E6, -5px -5px 8px 0 #FFFFFF;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        margin-right: 15px;
        margin-top: 20px;
        background: #ECF0F3;
        cursor: pointer;

        &.last-item {
          margin-right: 0;
        }

        .mini-card-content {
          flex: 1;
          display: flex;
          position: relative;
          justify-content: center;

          .mini-card-inner {
            flex: 1;
            margin: 5px;
            margin-bottom: 10px;
            background: #FAFAF0;
            border-radius: 12px;
            border: 1px solid #ECE271;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }

          .description-list {
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            max-height: 108px;
            align-items: flex-start;
            justify-content: flex-start;

            .description-item {
              background: rgba(235, 210, 16, 0.15);
              border-radius: 8px;
              height: 40px;
              margin-top: 10px;
              display: flex;
              align-items: center;
              position: relative;
              margin-left: 10px;
              padding: 0 10px;

              .description-text {
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #5E6779;
                line-height: 20px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 170px;
              }
            }
          }

          .mini-card-actions {
            display: flex;
            height: 34px;
            justify-content: flex-end;
            margin-bottom: 10px;
            padding: 0 10px;

            .more-indicator {
              width: 38px;
              height: 24px;
              background: rgba(94, 103, 121, 0.1);
              border-radius: 19px 19px 19px 2px;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #5E6779;
              line-height: 20px;
              display: flex;
              align-items: center;
              padding-left: 8px;
            }

            .view-btn {
              width: 58px;
              height: 30px;
              background: rgba(74, 124, 232, 0.15);
              border-radius: 20px;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              color: #4A7CE8;
              line-height: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              align-self: flex-end;
            }
          }

          .card-arrow {
            position: absolute;
            width: 16px;
            height: 12px;
            bottom: 0;
          }
        }

        .bed-info {
          display: flex;
          margin-bottom: 10px;
          align-items: center;
          justify-content: center;
          padding: 0 10px;
          position: relative;

          .bed-icon {
            width: 20px;
            height: 20px;
            margin-right: 5px;
            background: url('../../../assets/icon_dean_home_bg_card_icon_6.png') no-repeat;
            background-size: contain;
          }

          .bed-name {
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            line-height: 20px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 175px;
            color: #5E6779;
          }

          .bed-tooltip {
            position: absolute;
            background: #FFFFFF;
            z-index: 10000;
            top: -40px;
            padding: 10px;
            border-radius: 8px;
            display: none;
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            line-height: 20px;
            white-space: wrap;
            overflow-wrap: break-word;
            color: rgba(94, 103, 121, 1);
          }
        }

        &:hover {
          background: #DFE8FC;

          .bed-icon {
            background-image: url('../../../assets/icon_dean_home_bg_card_icon_7.png');
          }

          .bed-name {
            color: #4A7CE8;
          }

          .bed-tooltip,
          .description-item:hover ~ .bed-tooltip {
            display: block;
          }
        }
      }

      .carousel-arrow {
        width: 96px;
        height: 96px;
        top: 75px;
        z-index: 1;
		position: absolute;
		z-index: 2;
        cursor: pointer;
        user-select: none;

        &.left {
          left: -5px;
        }

        &.right {
          right: -5px;
        }
      }
    }

    .service-tags {
			display: flex;
			margin-left: 20px;

			.tag-container {
				// 基础容器样式：用变量统一控制，避免硬编码
				background: $tag-container-bg;
				border-radius: $tag-container-radius;
				border: $tag-container-border;
				width: $tag-container-width;
				height: $tag-container-height;
				position: relative;
				display: flex;
				flex-direction: column;
				justify-content: center;
				padding: 0 5px; // 增加内边距，避免标签贴边

				// 角落图标：统一定位逻辑，修复原代码中位置偏移问题
				.tag-corner {
					width: 20px;
					height: 20px;
					position: absolute;
					// 修复原代码中 left: -3px 导致图标溢出容器的问题
					left: 0;
					top: 0;
					transform: translate(-3px, -3px); // 用 transform 精准控制偏移

					&.bottom-right {
						left: auto;
						top: auto;
						right: 0;
						bottom: 0;
						transform: translate(3px, 3px); // 对称偏移
					}
				}

				// 标签行容器：复用样式，避免重复代码
				.tag-row {
					display: flex;
					align-items: center;
					justify-content: flex-start;
					margin: 8px 0; // 行与行之间增加间距，避免拥挤

					// 单个标签：统一结构和间距
					.tag-item {
						display: flex;
						align-items: center;
						margin-left: $tag-item-margin-x;

						// 标签图标：统一尺寸，避免拉伸
						img {
							width: $tag-item-icon-size;
							height: $tag-item-icon-size;
							object-fit: contain; // 确保图标比例正常
						}

						// 标签文本：统一宽度和样式，避免文字换行混乱
						span {
							font-size: $tag-text-size;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: $tag-text-color;
							line-height: 20px;
							margin-left: 5px;
							white-space: nowrap; // 禁止文本换行
							// 按原需求设置固定宽度，用变量统一管理
							&.width-sm {
								width: 56px;
							}
							&.width-lg {
								width: 109px;
							}
						}

						// 最后一个标签：清除右侧间距，避免行内溢出
						&:last-child {
							margin-right: 0;
						}
					}

					// 分割线：统一样式，修复原代码中间距不一致问题
					.tag-divider {
						width: 1px;
						height: $divider-height;
						background: $divider-bg;
						margin-left: $divider-margin-x;
					}
				}
			}
		}
  }

  // 提示弹窗样式
  .tip-popup {
    position: absolute;
    top: -200px;
    left: 336px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tip-content {
      width: 529px;
      background: #5E6779;
      border-radius: 8px;
      padding: 20px 20px 15px;

      .tip-text-container {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        padding: 10px 15px;
        position: relative;

        .tip-text-mask {
          position: absolute;
          height: 8px;
          background: rgba(243, 183, 61, 0.3);
          left: 120px;
          top: 25px;
          width: 110px;
          &::after {
            content: '';
            position: absolute;
            height: 8px;
            background: rgba(243, 183, 61, 0.3);
            left: 200px;
            top: 24px;
            width: 63px;
          }
          &::before {
            content: '';
            position: absolute;
            height: 8px;
            background: rgba(243, 183, 61, 0.3);
            left: 327px;
            top: 24px;
            width: 16px;
          }
        }

        .tip-text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 200;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 24px;
          position: relative;
          z-index: 1;
        }
      }

      .tip-actions {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .tip-meta {
          display: flex;

          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 200;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.5);
            line-height: 24px;
          }

          .skip-tip {
            margin-left: 15px;
            cursor: pointer;
          }
        }

        .next-btn {
          width: 72px;
          height: 30px;
          background: #4A7CE8;
          border-radius: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }

    .tip-arrow {
      width: 38px;
      height: 12px;
    }
  }

  // 富文本样式
  ::v-deep .richTextDiv {
    .richContentStyle {
      display: flex;
    }
    .richTextStyleNormal {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #5E6779;
      line-height: 20px;
    }
    .richTextStyleRed {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: rgba(255, 113, 134, 1);
      line-height: 20px;
    }
  }
}
</style>








